const LEAVE_PATHS = ['/caregivers', '/clients'] as const;

function pathnameLeavesInbox(pathname: string): boolean {
    return LEAVE_PATHS.some(
        (path) => pathname === path || pathname.startsWith(`${path}/`),
    );
}

// Intercept caregiver and client in-app links so the operator stays on
// Conversations and the profile opens in a modal instead. Outreach
// detail links (/outreaches/$id) stay clickable so footnote "Open
// outreach" can leave the inbox on purpose.
export function inboxLeaveNavigation(href: string): {
    readonly leaves: boolean;
    readonly caregiverId: string | null;
} {
    let url: URL;
    try {
        url = new URL(href, 'http://localhost');
    } catch {
        return { leaves: false, caregiverId: null };
    }
    if (!pathnameLeavesInbox(url.pathname)) {
        return { leaves: false, caregiverId: null };
    }
    return {
        leaves: true,
        caregiverId: url.searchParams.get('caregiverId'),
    };
}
